export default {
  GET_ARTICLE_INFO: 'GET_ARTICLE_INFO',
  SET_ARTICLE_INFO: 'SET_ARTICLE_INFO',
  SET_ARTICLE_CONTENT: 'SET_ARTICLE_CONTENT',
  SET_ARTICLE_LEFTLIST: 'SET_ARTICLE_LEFTLIST'
}



// WEBPACK FOOTER //
// ./src/views/Article/store/types.js